'use strict';

var _regeneratorRuntime = require("/Users/juhomi/projects/centa_pwa/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/Users/juhomi/projects/centa_pwa/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/Users/juhomi/projects/centa_pwa/node_modules/@babel/runtime/helpers/asyncToGenerator");

var delay = require('delay');

var pMinDelay =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(promise, minimumDelay, options) {
    var promiseError, value;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _objectSpread({
              delayRejection: true
            }, options);

            if (options.delayRejection) {
              promise = promise.catch(function (error) {
                promiseError = error;
              });
            }

            _context.next = 4;
            return Promise.all([promise, delay(minimumDelay)]);

          case 4:
            value = _context.sent;
            return _context.abrupt("return", promiseError ? Promise.reject(promiseError) : value[0]);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function pMinDelay(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = pMinDelay; // TODO: Remove this for the next major release

module.exports.default = pMinDelay;